import * as DataUtils from './DataUtils.js';

export const GetEquipos = async (prefijo, objetoFiltro, pais, tipoEquipo, nombre, categoria) => {
  let url = '';
  let separador = '?';
  if (prefijo) {
    url = prefijo + '/' + objetoFiltro.id + '/rivales/';
  }
  url += 'equipos';
  if (pais) {
    url += separador + 'pais=' + pais.id;
    separador = '&';
  }
  if (tipoEquipo && tipoEquipo.codigo) {
    url += separador + 'tipoEquipo=' + tipoEquipo.codigo;
    separador = '&';
  }
  if (categoria && categoria.codigo) {
    url += separador + 'categoria=' + categoria.codigo;
    separador = '&';
  }
  if (nombre) {
    url += separador + 'nombreParcial=' + nombre;
  }
  return DataUtils.FetchLista(url);
};
